<main class="customer-layout">
  <div class="customer-layout-main">
    <section class="customer-layout-body">
      <a [routerLink]="'/'" class="customer-layout-body__header">
        <img
          [lazyLoad]="'assets/images/adtrack-logo.svg'"
          [defaultImage]="null | dominantColorSvg"
          height="195"
          alt="Adtrack's logo"
        />
      </a>
      <div class="customer-layout-body__content">
        <router-outlet></router-outlet>
      </div>
    </section>

    <aside #aside class="customer-layout-sidemenu">
      <a [routerLink]="'/'" class="customer-layout-sidemenu__logo">
        <img
          [lazyLoad]="'assets/images/adtrack-logo.svg'"
          [defaultImage]="null | dominantColorSvg"
          height="47"
          alt="Adtrack's logo"
        />
      </a>

      <div class="customer-layout-sidemenu__content">
        <ng-scrollbar>
          <img
            class="customer-layout-sidemenu__illustration"
            [lazyLoad]="'assets/icons/customer.svg'"
            [defaultImage]="null | dominantColorSvg"
            height="195"
            alt="customer"
          />
          <section class="customer-layout-sidemenu__links">
            <div>
              <h6>Contactez-nous</h6>
              <p>
                <img
                  [lazyLoad]="'assets/icons/phone-call.svg'"
                  [defaultImage]="null | dominantColorSvg"
                  width="25"
                  alt="phone"
                />
                <a href="tel:+2250000000000">
                  <span>+225 07 16 90 60 98</span>
                </a>
              </p>
              <p>
                <img
                  [lazyLoad]="'assets/icons/letter.svg'"
                  [defaultImage]="null | dominantColorSvg"
                  width="25"
                  alt="letter"
                />
                <a href="mailto:mail@adtrack.com">
                  <span>adtrackgds2026&#64;gmail.com</span>
                </a>
              </p>
            </div>

            <div>
              <h6>Localisation</h6>
              <p>
                <img
                  [lazyLoad]="'assets/icons/map.svg'"
                  [defaultImage]="null | dominantColorSvg"
                  width="25"
                  alt="map"
                />
                <span>Riviera Palmeraie</span>
              </p>
            </div>

            <div>
              <h6>Suivez nous</h6>
              <p>
                <img
                  [lazyLoad]="'assets/icons/facebook.svg'"
                  [defaultImage]="null | dominantColorSvg"
                  width="25"
                  alt="facebook"
                />
                <a href="http://facebook.com" target="_blank">
                  <span>Facebook</span>
                </a>
              </p>
              <p>
                <img
                  [lazyLoad]="'assets/icons/linkedin.svg'"
                  [defaultImage]="null | dominantColorSvg"
                  width="25"
                  alt="linkedin"
                />
                <a href="http://facebook.com" target="_blank">
                  <span>Linkedin</span>
                </a>
              </p>
            </div>
          </section>
        </ng-scrollbar>
      </div>
    </aside>
  </div>

  <div class="customer-layout-footer" #footer>
    <p>
      <small>Copyright &copy; {{ currentYear }}</small>
      <small>Powered by VEONE</small>
    </p>
  </div>
</main>
